import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bulkActions", "bulkCount", "statusDropdown", "menuDropdown"]

  connect() {
    this.updateBulkVisibility()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateBulkVisibility()
  }

  toggleOne() {
    this.updateBulkVisibility()
  }

  updateBulkVisibility() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    if (this.hasBulkActionsTarget) {
      this.bulkActionsTarget.classList.toggle("hidden", checked.length === 0)
    }
    if (this.hasBulkCountTarget) {
      this.bulkCountTarget.textContent = checked.length
    }
  }

  showStatus(event) {
    const id = event.currentTarget.dataset.rcId
    document.querySelectorAll('[data-status-menu]').forEach(el => {
      if (el.dataset.statusMenu !== id) el.classList.add('hidden')
    })
    const menu = document.querySelector(`[data-status-menu="${id}"]`)
    if (menu) menu.classList.toggle('hidden')
    event.stopPropagation()
  }

  showMenu(event) {
    const id = event.currentTarget.dataset.rcId
    document.querySelectorAll('[data-action-menu]').forEach(el => {
      if (el.dataset.actionMenu !== id) el.classList.add('hidden')
    })
    const menu = document.querySelector(`[data-action-menu="${id}"]`)
    if (menu) menu.classList.toggle('hidden')
    event.stopPropagation()
  }

  closeMenus(event) {
    document.querySelectorAll('[data-status-menu]').forEach(el => el.classList.add('hidden'))
    document.querySelectorAll('[data-action-menu]').forEach(el => el.classList.add('hidden'))
  }
}
